import { GetKindsDocument } from '@/api/queries';
import SelectFromQuery from '../SelectFromQuery';

const SelectKind = (props) => (
  <SelectFromQuery
    cache="Kinds"
    placeholder="All Kinds"
    query={GetKindsDocument}
    selector={(data) =>
      (data?.getFilters?.filters?.kind || []).map((opt) => ({
        label: opt.displayName,
        value: opt.id,
      }))
    }
    {...props}
  />
);

export default SelectKind;
